// Путь: D:\QR\QR-WEB\dashboard\src\App.js
// Название: Main Router - DARY B2B + Brand
// Версия: 4.0.0
// Дата: 27.12.2025

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// ===== AUTH COMPONENTS =====
import { Login } from './components/Auth/Login';
import { Register } from './components/Auth/Register';
import VerifyEmail from './components/Auth/VerifyEmail';
import ForgotPassword from './components/Auth/ForgotPassword';
import DaryLanding from './components/Landing/DaryLanding';
import GiftLanding from './components/Landing/GiftLanding';

// ===== USER PAGES =====
import { Dashboard } from './components/Dashboard/Dashboard';
import { CreateQR } from './components/QR/CreateQR';
import ScanQR from './components/QR/ScanQR';
import Profile from './components/Profile';
import TransactionHistory from './components/TransactionHistory';
import BrandStore from './components/User/BrandStore';
import BrandStorePage from './components/User/BrandStorePage';

// ===== BUSINESS COMPONENTS =====
import BusinessDashboard from './components/Dashboard/BusinessDashboard';
import BusinessQRCodes from './components/Business/BusinessQRCodes';
import BusinessBulkCreate from './components/Business/BusinessBulkCreate';
import BusinessAnalytics from './components/Business/BusinessAnalytics';
import BusinessProfile from './components/Business/BusinessProfile';
import B2BAnalytics from './components/Business/B2BAnalytics';
import B2BCampaignDetails from './components/Business/B2BCampaignDetails';
import BrandCampaignCreate from './components/Business/BrandCampaignCreate';
import BrandCampaignWizard from './components/Business/BrandCampaignWizard';
import ReferralCampaignWizard from './components/Business/ReferralCampaignWizard';
import BrandGiveawayWizard from './components/Business/BrandGiveawayWizard';
import MyReferrals from './components/User/MyReferrals';
import MyPromocodes from './components/User/MyPromocodes';
import BrandWallet from './components/Business/BrandWallet';

// ===== BUSINESS VOUCHER COMPONENTS (NEW) =====
import BusinessCreateVoucher from './components/Business/BusinessCreateVoucher';
import BusinessMyVouchers from './components/Business/BusinessMyVouchers';
import BusinessClaimVoucher from './components/Business/BusinessClaimVoucher';

// ===== BUSINESS EXCHANGE MODULE =====
import ExchangeHistory from './components/Business/ExchangeHistory';
import ExchangeDashboard from './components/Business/ExchangeDashboard';

// ===== USER COMPONENTS (Deposit/Withdraw) =====
import UserDeposit from './components/User/UserDeposit';
import UserWithdraw from './components/User/UserWithdraw';

// ===== USER VOUCHER COMPONENTS =====
import CreateVoucher from './components/User/CreateVoucher';
import MyVouchers from './components/User/MyVouchers';
import ClaimVoucher from './components/User/ClaimVoucher';

// ===== BUSINESS COMPONENTS (Deposit/Withdraw) =====
import BusinessDeposit from './components/Business/BusinessDeposit';
import BusinessWithdraw from './components/Business/BusinessWithdraw';
import BusinessBilling from './components/Business/BusinessBilling';
import BusinessMarketplace from './components/Business/BusinessMarketplace';
import FluxCampaignWizard from './components/Business/FluxCampaignWizard';
import CampaignsList from './components/Business/CampaignsList';
import BusinessContacts from './components/Business/BusinessContacts';
import CampaignCreate from './components/Business/CampaignCreate';
import BusinessLeads from './components/Business/BusinessLeads';
import BusinessPromocodes from './components/Business/BusinessPromocodes';

// ===== ADMIN COMPONENTS =====
import AdminUsers from './components/Admin/AdminUsers/AdminUsers';
import AdminUserRoles from './components/Admin/AdminUsers/AdminUserRoles';
import AdminUserBlocked from './components/Admin/AdminUsers/AdminUserBlocked';
import AdminQRCodes from './components/Admin/AdminQRCodes/AdminQRCodes';
import AdminTransactions from './components/Admin/AdminTransactions/AdminTransactions';
import AdminSecurity from './components/Admin/AdminSecurity/AdminSecurity';
import AdminStatistics from './components/Admin/AdminStatistics/AdminStatistics';
import AdminTRON from './components/Admin/AdminTRON/AdminTRON';
import AdminTRONReserves from './components/Admin/AdminTRON/AdminTRONReserves';
import AdminTRONSettings from './components/Admin/AdminTRON/AdminTRONSettings';
import AdminDaryUniversal from './components/Admin/AdminDary/AdminDaryUniversal';
import AdminDaryUsers from './components/Admin/AdminDary/AdminDaryUsers';
import AdminDaryReferrals from './components/Admin/AdminDary/AdminDaryReferrals';
import AdminBusinesses from './components/Admin/AdminBusinesses/AdminBusinesses';
import AdminApprove from './components/Admin/AdminBusinesses/AdminApprove';
import AdminAnalytics from './components/Admin/AdminBusinesses/AdminAnalytics';
import AdminSettings from './components/Admin/AdminSettings/AdminSettings';
import AdminQRPromos from './components/Admin/AdminQRCodes/AdminQRPromos';
import AdminQRGifts from './components/Admin/AdminQRCodes/AdminQRGifts';
import AdminTransactionsPending from './components/Admin/AdminTransactions/AdminTransactionsPending';
import AdminTransactionsFailed from './components/Admin/AdminTransactions/AdminTransactionsFailed';
import AdminSecurityAlerts from './components/Admin/AdminSecurity/AdminSecurityAlerts';
import AdminSecurityLogs from './components/Admin/AdminSecurity/AdminSecurityLogs';

// ===== ADMIN CRYPTO COMPONENTS (DISABLED - Strategy 2026) =====

// ===== ADMIN DASHBOARD =====
import AdminDashboard from './components/Dashboard/AdminDashboard';

// ===== ADMIN VOUCHERS COMPONENTS (NEW v3.4) =====
import AdminVouchers from './components/Admin/AdminVouchers/AdminVouchers';
import AdminVoucherTemplates from './components/Admin/AdminVouchers/AdminVoucherTemplates';
import AdminExchangeProducts from './components/Admin/AdminGiftCards/AdminExchangeProducts';
import AdminGiftCardOrders from './components/Admin/AdminGiftCards/AdminGiftCardOrders';

// ===== ADMIN VERIFICATION COMPONENTS (NEW v3.4) =====
import AdminVerification from './components/Admin/AdminVerification/AdminVerification';
import AdminBilling from './components/Admin/AdminBilling';
import { AdminCampaigns, AdminCampaignDetail, AdminCampaignAnalytics } from './components/Admin/AdminCampaigns';
import { AdminAdManager, AdminAdCampaignDetail } from './components/Admin/AdminAdManager';

// ===== ADMIN NEW COMPONENTS (Strategy 2026 v2.0) =====
import AdminSubscriptions from './components/Admin/AdminSubscriptions/AdminSubscriptions';
import AdminWallets from './components/Admin/AdminWallets/AdminWallets';
import AdminBrandGifts from './components/Admin/AdminBrandGifts/AdminBrandGifts';
import AdminPromocodes from './components/Admin/AdminPromocodes/AdminPromocodes';
import AdminLeads from './components/Admin/AdminLeads/AdminLeads';
import AdminCommissions from './components/Admin/AdminCommissions/AdminCommissions';

// ===== LAYOUTS =====
import UserLayout from './components/Layout/UserLayout';
import BusinessLayout from './components/Layout/BusinessLayout';
import AdminLayout from './components/Layout/AdminLayout';

import './App.css';

// ═══════════════════════════════════════════════════════════════════════════════
// HELPER FUNCTIONS
// ═══════════════════════════════════════════════════════════════════════════════

const getUserRole = () => {
  const user = localStorage.getItem('user');
  if (user) {
    try {
      const userData = JSON.parse(user);
      return userData.role || 'user';
    } catch (e) {
      return 'user';
    }
  }
  return localStorage.getItem('userRole') || 'user';
};

const getUserData = () => {
  const user = localStorage.getItem('user');
  if (user) {
    try {
      return JSON.parse(user);
    } catch (e) {
      return { email: localStorage.getItem('userEmail') || 'User' };
    }
  }
  return { email: localStorage.getItem('userEmail') || 'User' };
};

// ═══════════════════════════════════════════════════════════════════════════════
// PROTECTED ROUTE COMPONENT
// ═══════════════════════════════════════════════════════════════════════════════

const ProtectedRoute = ({ children, allowedRoles }) => {
  const isAuthenticated = !!localStorage.getItem('authToken') || !!localStorage.getItem('userId');
  const userRole = getUserRole();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// ═══════════════════════════════════════════════════════════════════════════════
// LAYOUT WRAPPER COMPONENT
// ═══════════════════════════════════════════════════════════════════════════════

const LayoutWrapper = ({ children }) => {
  const userRole = getUserRole();
  const userData = getUserData();

  switch (userRole) {
    case 'business':
      return <BusinessLayout user={userData}>{children}</BusinessLayout>;
    case 'admin':
      return <AdminLayout user={userData}>{children}</AdminLayout>;
    case 'user':
    default:
      return <UserLayout user={userData}>{children}</UserLayout>;
  }
};

// ═══════════════════════════════════════════════════════════════════════════════
// MAIN APP COMPONENT
// ═══════════════════════════════════════════════════════════════════════════════

function App() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>⏳ Загрузка...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/" element={<DaryLanding />} />`n        <Route path="/d/:slug" element={<GiftLanding />} />`n        <Route path="/claim" element={<ClaimVoucher />} />
        {/* PROTECTED USER/BUSINESS/ADMIN ROUTES (Common) */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['user', 'business', 'admin']}>
              <LayoutWrapper>
                <Dashboard />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/create-qr"
          element={
            <ProtectedRoute allowedRoles={['user', 'business', 'admin']}>
              <LayoutWrapper>
                <CreateQR />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/scan-qr"
          element={
            <ProtectedRoute allowedRoles={['user', 'business', 'admin']}>
              <LayoutWrapper>
                <ScanQR />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/history"
          element={
            <ProtectedRoute allowedRoles={['user', 'business', 'admin']}>
              <LayoutWrapper>
                <TransactionHistory />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedRoles={['user', 'business', 'admin']}>
              <LayoutWrapper>
                <Profile />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* USER DEPOSIT/WITHDRAW ROUTES */}
        <Route
          path="/deposit"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <UserWithdraw />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/vouchers/create"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <CreateVoucher />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/vouchers/my"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <MyVouchers />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
		<Route
          path="/referrals"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <MyReferrals />
             </LayoutWrapper>
            </ProtectedRoute>
         }
        />

        <Route
          path="/my-promocodes"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <MyPromocodes />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/vouchers/claim"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <ClaimVoucher />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/brand-store"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <BrandStore />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/brand-store/:slug"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <BrandStorePage />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/withdraw"
          element={
            <ProtectedRoute allowedRoles={['user']}>
              <LayoutWrapper>
                <UserWithdraw />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        {/* BUSINESS ROUTES */}
        <Route
          path="/business/dashboard"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessDashboard />
              </LayoutWrapper>
            </ProtectedRoute>
          }
		/>
        <Route
          path="/business/wallet"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BrandWallet />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business/qr-codes"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessQRCodes />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/bulk-create"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessBulkCreate />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/analytics"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessAnalytics />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/profile"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessProfile />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/deposit"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessDeposit />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/withdraw"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessWithdraw />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* BUSINESS VOUCHER ROUTES */}
		
		<Route
          path="/business/billing"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessBilling />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
        <Route
          path="/business/marketplace"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessMarketplace />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />		
        
        {/* B2B CAMPAIGNS */}
        <Route
          path="/business/b2b/create"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <CampaignCreate campaignType="b2b" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business/b2b/campaigns"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <CampaignsList campaignType="b2b" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		<Route
          path="/business/b2b/analytics"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <B2BAnalytics />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/b2b/campaigns/:id"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <B2BCampaignDetails />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* BRAND CAMPAIGNS */}
        
		<Route
          path="/business/brand/create"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BrandCampaignCreate />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business/brand/campaigns"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <CampaignsList campaignType="brand" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
        <Route
          path="/business/brand/campaigns/:id/wizard"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BrandCampaignWizard />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />	
		
        <Route
          path="/business/brand/referral/:id/wizard"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <ReferralCampaignWizard />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
            path="/business/brand/giveaway/:id/wizard"
            element={
              <ProtectedRoute allowedRoles={['business']}>
                <LayoutWrapper>
                  <BrandGiveawayWizard />
                </LayoutWrapper>
              </ProtectedRoute>
            }
          />
		
        <Route
          path="/business/brand/analytics"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessAnalytics campaignType="brand" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* CONTACTS ROUTES */}
        <Route
          path="/business/contacts/employees"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessContacts contactType="employees" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business/contacts/customers"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessContacts contactType="customers" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business/contacts/leads"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessContacts contactType="leads" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />		
		
        {/* FLUX AI CAMPAIGNS */}
        <Route
          path="/business/campaigns/new"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <CampaignCreate />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business/campaigns"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <CampaignsList />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business/contacts"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessContacts />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business/campaigns/:id/flux"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <FluxCampaignWizard />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
        <Route
          path="/business/vouchers/create"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessCreateVoucher />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/vouchers/my"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessMyVouchers />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/vouchers/claim"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessClaimVoucher />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* BUSINESS EXCHANGE ROUTES */}
        <Route
          path="/business/exchange"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <ExchangeDashboard />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/exchange/history"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <ExchangeHistory />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/leads"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessLeads />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/business/promocodes"
          element={
            <ProtectedRoute allowedRoles={['business']}>
              <LayoutWrapper>
                <BusinessPromocodes />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ═══════════════════════════════════════════════════════════════════ */}
        {/* ADMIN ROUTES */}
        {/* ═══════════════════════════════════════════════════════════════════ */}

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminDashboard />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/users"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminUsers />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/users/roles"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminUserRoles />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/users/blocked"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminUserBlocked />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN BUSINESSES */}
        <Route
          path="/admin/business"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminBusinesses />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/businesses"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminBusinesses />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/business/approve"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminApprove />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/business/analytics"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminAnalytics />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN VERIFICATION (NEW v3.4) */}
        <Route
          path="/admin/verification"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminVerification />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN BILLING (Strategy 2026) */}
        <Route
          path="/admin/billing"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminBilling />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
		{/* ADMIN SUBSCRIPTIONS (Strategy 2026 v2.0) */}
        <Route
          path="/admin/subscriptions"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminSubscriptions />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/wallets"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminWallets />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
		<Route
          path="/admin/dary"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminDaryUniversal />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
		<Route
          path="/admin/dary/users"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminDaryUsers />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/dary/referrals"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminDaryReferrals />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/brand-gifts"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminBrandGifts />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/promocodes"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminPromocodes />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/leads"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminLeads />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/commissions"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminCommissions />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
        {/* CAMPAIGNS */}
        <Route
          path="/admin/campaigns"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminCampaigns />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/campaigns/b2b"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminCampaigns defaultType="b2b" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/campaigns/brand"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminCampaigns defaultType="brand" />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
		<Route
          path="/admin/campaigns/:id"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminCampaignDetail />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
		<Route
          path="/admin/campaigns/analytics"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminCampaignAnalytics />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
		
        {/* AD MANAGER */}
        <Route
          path="/admin/ad-manager"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminAdManager />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/ad-manager/:id"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminAdCampaignDetail />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN VOUCHERS (NEW v3.4) */}
        <Route
          path="/admin/vouchers"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminVouchers />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/vouchers/templates"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminVoucherTemplates />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/vouchers/expired"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminVouchers />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN GIFT CARDS */}
        <Route
          path="/admin/giftcards/products"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminExchangeProducts />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/giftcards/orders"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminGiftCardOrders />
              </LayoutWrapper>
            </ProtectedRoute>
          }
		/>
        {/* ADMIN QR (OLD - keeping for compatibility) */}
        <Route
          path="/admin/qr"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminQRCodes />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/qr/promos"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminQRPromos />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/qr/gifts"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminQRGifts />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN TRANSACTIONS */}
        <Route
          path="/admin/transactions"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminTransactions />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/transactions/pending"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminTransactionsPending />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/transactions/failed"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminTransactionsFailed />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN SECURITY */}
        <Route
          path="/admin/security/ip"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminSecurity />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/security/ip-blocks"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminSecurity />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/security/alerts"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminSecurityAlerts />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/security/logs"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminSecurityLogs />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN TRON/BLOCKCHAIN - DISABLED Strategy 2026 */}
        <Route path="/admin/tron/*" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/admin/blockchain/*" element={<Navigate to="/admin/dashboard" replace />} />

        {/* ADMIN STATISTICS */}
        <Route
          path="/admin/analytics"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminStatistics />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN SETTINGS */}
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <LayoutWrapper>
                <AdminSettings />
              </LayoutWrapper>
            </ProtectedRoute>
          }
        />

        {/* ADMIN CRYPTO ROUTES - DISABLED Strategy 2026 */}
        <Route path="/admin/crypto/*" element={<Navigate to="/admin/dashboard" replace />} />

        {/* 404 - NOT FOUND */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;









